<template>
  <teleport v-if="widget" :to="'#' + dest">
    <div v-if="vehicle" class="text-center">
      <img :src="vehicle.images.exterior[0].url" class="orm-w100" />
      <p>
        <span class="orm-mr-8"
          >{{ vehicle.vehicle_name }}
          {{ i18n("autoabo/super_top_vehicletext") || "gefällig?" }}</span
        >
        <button
          class="orm-button__cta arrow outline small"
          @click="getCars(vehicle)"
        >
          {{ i18n("autoabo/super_top_buttontext") || "Zeig mal!" }}
        </button>
      </p>
    </div>
    <div v-else>
      <div
        class="orm-preload-page orm-preload-page-static"
        v-if="!disablecontainer"
      >
        <i class="fa fa-spinner-third orm-rotate360"></i>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent, toRef } from "vue";
import store from "@/store";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "AboV2SuperTopVehicle",
  components: {},
  mixins: [i18n, stripHTML],
  setup(props) {
    const dest = toRef(props, "teleport").value;
    let widget = false;
    const myEle = document.getElementById(dest);
    if (myEle !== null) {
      widget = true;
    }

    return {
      widget,
      dest,
      // offers,
    };
  },
  data() {
    return {
      vehicles: null,
      vehicle: null,
      offers: null,
      demo: process.env.VUE_APP_DEMO,
      carcategory: [],
      sttype: "Auto-Abo",
      disablecontainer: false,
      filtercategory: null,
    };
  },
  props: {
    teleport: {
      type: String,
      default: "crentAboSuperTopVehicle",
    },
  },
  async created() {
    const teleportWrapper = document.getElementById(this.teleport);
    if (teleportWrapper == null) {
      return;
    }

    const vehicles = await store.dispatch("cargroup/GET_VEHICLES_V2", {
      super_top: true,
    });

    this.vehicles = JSON.parse(JSON.stringify(vehicles.vehicles));

    this.vehicle = this.vehicles[0];

    if (!this.vehicle)
      this.disablecontainer = true;

    console.log(this.vehicle);
  },
  methods: {
    openContact(car) {
      console.log("not implemented");
    },
    async getCars() {
      await store.dispatch("userSession/SET_VEHICLE", this.vehicle);
      await store.dispatch("userSession/SET_STATION", this.vehicle.location.id);
      store
        .dispatch("userSession/SET_CARGROUP", this.vehicle.vehicle_group.id)
        .then(() => {
          store.dispatch("reservation/DELETE_TARIF");
          store.dispatch("reservation/SET_DRIVEDISTANCE", null);
          store.dispatch("stations/SET_OPENINGTIMES").then(() => {
            store
              .dispatch("reservation/CALCULATE_PRICE", {
                id: this.vehicle.vehicle_group.id,
                extras: false,
                vehicle_id: this.vehicle.id,
              })
              .then((tarif) => {
                // console.log(tarif);
                if (!tarif.main_rates) return;
                // console.log(tarif.main_rates.length);
                if (tarif.main_rates.length == 0) {
                  // const cartype = {};
                  // cartype[this.car["vehicle_category"][0]["id"]] = true;
                  // store.dispatch("userSession/SET_CARCATEGORY", cartype);
                  // if (process.env.VUE_APP_STANDALONE == "true") {
                  //   this.$router.push({ name: "Reservation_Step1" });
                  // } else {
                  //   window.location.href =
                  //     process.env.VUE_APP_BASE_URL +
                  //     process.env.VUE_APP_RESERVATION_PATH +
                  //     process.env.VUE_APP_RESERVATION_PATH_STEP1;
                  // }
                } else {
                  store
                    .dispatch("reservation/SET_RESERVATION_TARIFS", tarif)
                    .then(() => {
                      routeToSteps(this, 2);
                    });
                }
              });
          });
        });

      //store.dispatch("userSession/SET_CARGROUP", this.car.id).then(() => {
      //  routeToSteps(this, 2);
      //});
    },
  },
});
</script>
